import React from 'react';
import { connect } from 'react-redux';
import NavSearchBar from './NavSearchBar';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: null,
      mobileOpen: false,
      mobileSubMenu: null,
      scrolled: false,
    };
    this.navRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    this.setState({ scrolled: window.scrollY > 60 });
  }

  handleOutsideClick = (e) => {
    if (this.navRef.current && !this.navRef.current.contains(e.target)) {
      this.setState({ openMenu: null });
    }
  }

  toggleMenu = (name) => {
    this.setState(prev => ({ openMenu: prev.openMenu === name ? null : name }));
  }

  openMobile  = () => this.setState({ mobileOpen: true, mobileSubMenu: null });
  closeMobile = () => this.setState({ mobileOpen: false, mobileSubMenu: null });
  openSub     = (name) => this.setState({ mobileSubMenu: name });
  closeSub    = () => this.setState({ mobileSubMenu: null });

  render() {
    const { openMenu, mobileOpen, mobileSubMenu, scrolled } = this.state;
    const isWhiteBg = this.props.bgColor === 'white';
    const isHome = window.location.pathname === '/';

    let navBgClass;
    if (isWhiteBg) navBgClass = 'custom-nav white-bg';
    else if (isHome && !scrolled) navBgClass = 'bg-transparent';
    else navBgClass = 'yulia-header-background';

    return (
      <React.Fragment>
        <header className="header">
          <nav
            ref={this.navRef}
            className={'navbar navbar-expand-xl fixed-top ' + navBgClass}
          >
            <div className="container">
              <a className="navbar-brand" href="/">
                <img
                  src={isWhiteBg ? '/img/logo-color-1x.png' : '/img/logo-white-1x.svg'}
                  width="120"
                  alt="ExplorOFF logo"
                  className="img-fluid-exploroff"
                />
              </a>

              {/* Mobile search trigger — opens drawer with Where active */}
              <div className="nav-mobile-search-trigger" role="button" onClick={this.openMobile}>
                <i className="ti-search" />
                <span>Where to next?</span>
              </div>

              {/* Mobile hamburger */}
              <div
                className="navbar-toggler"
                role="button"
                aria-label="Open menu"
                onClick={this.openMobile}
                style={{ cursor: 'pointer' }}
              >
                <span className="ti-menu"></span>
              </div>

              {/* ── Desktop menu ── */}
              <div className="collapse navbar-collapse main-menu" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto align-items-center">

                  {/* Hiking Guides mega-menu */}
                  <li className={'nav-item mega-dropdown' + (openMenu === 'guides' ? ' mega-open' : '')}>
                    <a
                      className="nav-link"
                      href="/hiking-guides"
                      onClick={e => { e.preventDefault(); this.toggleMenu('guides'); }}
                    >
                      Hiking Guides
                    </a>
                    <div className="submenu mega-menu-panel">
                      <div className="row mx-0">
                        <div className="col-lg-4 mega-items-area" style={{ borderRight: '1px solid #e2eaed' }}>
                          <a className="mega-col-header" href="/hiking-guides">Hiking Basics</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-plan-sustainable-hiking-trip">Plan a Sustainable Trip</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-protect-yourself-from-wildlife-while-hiking">Wildlife Safety Guide</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-find-eco-friendly-hiking-gear">Eco-Friendly Gear</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-make-hiking-stick">Make a Hiking Stick</a>
                          <a className="dropdown-item mega-see-all" href="/hiking-guides">
                            See All Guides
                          </a>
                        </div>
                        <div className="col-lg-4 mega-items-area" style={{ borderRight: '1px solid #e2eaed' }}>
                          <a className="mega-col-header" href="/hiking-guides">Gear &amp; Prep</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-use-hiking-poles-correctly">How to Use Hiking Poles</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-lace-hiking-boots">How to Lace Hiking Boots</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-train-for-high-altitude-hiking">Train for High Altitude</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-pack-hiking-backpack-diagram">Pack a Hiking Backpack</a>
                          <a className="dropdown-item" href="/hiking-guides/how-to-prevent-blisters-when-hiking">Prevent Blisters</a>
                          <a className="dropdown-item mega-see-all" href="/hiking-guides">
                            See All Guides
                          </a>
                        </div>
                        <div className="col-lg-4 px-0">
                          <div className="mega-cta-card">
                            <img src="/img/chain-lakes-loop/chain-lakes-loop.webp" alt="Guided hiking tour Pacific Northwest" loading="lazy" />
                            <div className="mega-cta-card-body">
                              <span className="mega-cta-label">Guided Experience</span>
                              <p>Let our expert guides lead you through the most breathtaking trails in the Pacific Northwest.</p>
                              <a className="mega-cta-btn" href="https://www.airbnb.com/experiences/4670214"
                                 target="_blank" rel="noopener noreferrer">
                                Book Guided Tour
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mega-view-all-bar">
                        <a className="dropdown-item" href="/hiking-guides">
                          View All Hiking Guides
                          <i className="ti-arrow-right" style={{ marginLeft: '8px', fontSize: '0.75rem' }} />
                        </a>
                      </div>
                    </div>
                  </li>

                  {/* Itineraries mega-menu */}
                  <li className={'nav-item mega-dropdown' + (openMenu === 'itineraries' ? ' mega-open' : '')}>
                    <a
                      className="nav-link"
                      href="/itineraries"
                      onClick={e => { e.preventDefault(); this.toggleMenu('itineraries'); }}
                    >
                      Itineraries
                    </a>
                    <div className="submenu mega-menu-panel">
                      <div className="row mx-0">
                        <div className="col-lg-3 mega-items-area" style={{ borderRight: '1px solid #e2eaed' }}>
                          <span className="mega-col-header">Pacific Northwest</span>
                          <a className="dropdown-item" href="/itineraries/olympic-peninsula-loop">Olympic Peninsula Loop</a>
                          <a className="dropdown-item" href="/itineraries/chain-lakes-loop">Chain Lakes Loop</a>
                          <a className="dropdown-item" href="/itineraries/glacier-national-park-memorial-day">Glacier National Park</a>
                          <a className="dropdown-item" href="/itineraries/banff-national-park">Banff National Park</a>
                          <a className="dropdown-item mega-see-all" href="/itineraries">See All →</a>
                        </div>
                        <div className="col-lg-3 mega-items-area" style={{ borderRight: '1px solid #e2eaed' }}>
                          <span className="mega-col-header">American West</span>
                          <a className="dropdown-item" href="/itineraries/yellowstone-grand-teton">Yellowstone &amp; Grand Teton</a>
                          <a className="dropdown-item" href="/itineraries/utah-national-parks-road-trip">Utah National Parks Loop</a>
                          <a className="dropdown-item" href="/itineraries/grand-canyon-south-rim">Grand Canyon South Rim</a>
                          <a className="dropdown-item" href="/itineraries/rocky-mountain-national-park">Rocky Mountain NP</a>
                          <a className="dropdown-item" href="/itineraries/sedona-hiking">Sedona Red Rock</a>
                          <a className="dropdown-item" href="/itineraries/kayak-colorado-river">Colorado River Kayaking</a>
                          <a className="dropdown-item mega-see-all" href="/itineraries">See All →</a>
                        </div>
                        <div className="col-lg-3 mega-items-area" style={{ borderRight: '1px solid #e2eaed' }}>
                          <span className="mega-col-header">East Coast &amp; More</span>
                          <a className="dropdown-item" href="/itineraries/acadia-national-park">Acadia National Park</a>
                          <a className="dropdown-item" href="/itineraries/great-smoky-mountains-national-park">Great Smoky Mountains</a>
                          <a className="dropdown-item" href="/itineraries/blue-ridge-parkway">Blue Ridge Parkway</a>
                          <a className="dropdown-item" href="/itineraries/shenandoah-national-park">Shenandoah NP</a>
                          <a className="dropdown-item" href="/itineraries/boundary-waters-canoe-area">Boundary Waters</a>
                          <a className="dropdown-item mega-see-all" href="/itineraries">See All →</a>
                        </div>
                        <div className="col-lg-3 px-0">
                          <div className="mega-submit-card" style={{ borderRadius: 0, border: 'none', height: '100%' }}>
                            <img src="/img/utah-national-parks-road-trip/angels-landing-trail.png"
                                 alt="Submit your road trip itinerary" style={{ height: '120px', width: '100%', objectFit: 'cover' }} loading="lazy" />
                            <div className="mega-submit-card-body">
                              <a className="mega-submit-card-title" href="/submit-itinerary">
                                Submit Your Itinerary
                              </a>
                              <p>Been somewhere epic? Share your route and inspire the ExplorOFF community.</p>
                              <a className="mega-cta-btn mega-cta-btn-orange" href="/submit-itinerary" style={{ marginTop: '12px', display: 'inline-block' }}>Submit Itinerary</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mega-view-all-bar">
                        <a className="dropdown-item" href="/itineraries">
                          View All Itineraries
                          <i className="ti-arrow-right" style={{ marginLeft: '8px', fontSize: '0.75rem' }} />
                        </a>
                      </div>
                    </div>
                  </li>

                  {/* Destination Search */}
                  <li className="nav-item nav-search-wrapper" style={{ margin: '0 6px' }}>
                    <NavSearchBar />
                  </li>

                </ul>
              </div>
            </div>
          </nav>

          {/* ── Mobile drawer ── */}
          <div
            className={'mobile-drawer-overlay' + (mobileOpen ? ' open' : '')}
            onClick={this.closeMobile}
          />
          <div className={'mobile-drawer' + (mobileOpen ? ' open' : '')}>

            {/* Drawer header — teal background with white logo */}
            <div className="mobile-drawer-header">
              <a href="/" onClick={this.closeMobile}>
                <img src="/img/logo-white-1x.svg" width="60" alt="ExplorOFF" className="img-fluid-exploroff" />
              </a>
              <div className="mobile-drawer-close" onClick={this.closeMobile} role="button" aria-label="Close menu">
                <i className="ti-close" />
              </div>
            </div>

            {/* Search — Airbnb-style card in drawer */}
            <div className="mobile-drawer-search">
              <NavSearchBar mobile />
            </div>

            {/* Sliding panels */}
            <div className="mobile-drawer-panels">

              {/* Main menu panel */}
              <div className={'mobile-panel-main' + (mobileSubMenu ? ' slide-out' : '')}>
                <div className="mobile-menu-row has-sub" role="button" onClick={() => this.openSub('guides')}>
                  <span><i className="ti-map mobile-menu-icon" />Hiking Guides</span>
                  <i className="ti-angle-right" />
                </div>
                <div className="mobile-menu-row has-sub" role="button" onClick={() => this.openSub('itineraries')}>
                  <span><i className="ti-location-pin mobile-menu-icon" />Itineraries</span>
                  <i className="ti-angle-right" />
                </div>
              </div>

              {/* Sub-menu panel */}
              <div className={'mobile-panel-sub' + (mobileSubMenu ? ' slide-in' : '')}>
                <div className="mobile-back-row" role="button" onClick={this.closeSub}>
                  <i className="ti-angle-left" />
                  <span>{mobileSubMenu === 'guides' ? 'Hiking Guides' : 'Itineraries'}</span>
                </div>

                {mobileSubMenu === 'guides' && (
                  <>
                    <a className="mobile-sub-row mobile-sub-category" href="/hiking-guides?category=hiking-basics" onClick={this.closeMobile}>
                      <i className="ti-flag mobile-menu-icon" />Hiking Basics
                    </a>
                    <a className="mobile-sub-row mobile-sub-category" href="/hiking-guides?category=gear-prep" onClick={this.closeMobile}>
                      <i className="ti-bag mobile-menu-icon" />Gear &amp; Prep
                    </a>
                    <a className="mobile-sub-row mobile-sub-category" href="/hiking-guides?category=trail-guides" onClick={this.closeMobile}>
                      <i className="ti-map-alt mobile-menu-icon" />Trail Guides
                    </a>
                    <a className="mobile-sub-row mobile-sub-view-all" href="/hiking-guides" onClick={this.closeMobile}>View All Hiking Guides</a>
                  </>
                )}

                {mobileSubMenu === 'itineraries' && (
                  <>
                    <a className="mobile-sub-row mobile-sub-category" href="/itineraries?region=northwest" onClick={this.closeMobile}>
                      <i className="ti-location-pin mobile-menu-icon" />Pacific Northwest
                    </a>
                    <a className="mobile-sub-row mobile-sub-category" href="/itineraries?region=west" onClick={this.closeMobile}>
                      <i className="ti-location-pin mobile-menu-icon" />American West
                    </a>
                    <a className="mobile-sub-row mobile-sub-category" href="/itineraries?region=east" onClick={this.closeMobile}>
                      <i className="ti-location-pin mobile-menu-icon" />East Coast &amp; More
                    </a>
                    <a className="mobile-sub-row mobile-sub-view-all" href="/itineraries" onClick={this.closeMobile}>View All Itineraries</a>
                    <div className="mobile-sub-submit-wrap">
                      <a className="mobile-cta-submit" href="/submit-itinerary" onClick={this.closeMobile}>Submit Your Itinerary</a>
                    </div>
                  </>
                )}
              </div>

            </div>

          </div>

        </header>
      </React.Fragment>
    );
  }
}

export default connect((state) => ({}))(Header);
